import React from 'react';
import { Buttons } from 'components';
import Separator from 'components/common/Separator';
import DialogActions from '@mui/material/DialogActions';
import * as S from './Footer.styled';

const Footer = ({
  handleClose,
  handleSaveApp,
  isDisabled = false,
  typeSaveBtn = '',
  saveLabel = 'Save App',
}) => {
  return (
    <>
      <Separator width={'100%'} marginLeft={0} marginTop={32} />
      <DialogActions>
        <S.DialogFooterSection>
          <S.DialogFooterButtons>
            <Buttons.SecondaryNormal id='cancelButton' onClick={handleClose}>
              Cancel
            </Buttons.SecondaryNormal>
            <Buttons.PrimaryNormal
              type={typeSaveBtn}
              id='saveButton'
              onClick={handleSaveApp}
              isDisabled={isDisabled}
            >
              {saveLabel}
            </Buttons.PrimaryNormal>
          </S.DialogFooterButtons>
        </S.DialogFooterSection>
      </DialogActions>
    </>
  );
};

export default Footer;
